import { render, staticRenderFns } from "./_calendar.vue?vue&type=template&id=f506416c&"
import script from "./_calendar.vue?vue&type=script&lang=js&"
export * from "./_calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports